const footerLinks = [
  {
    title: '角色介绍',
    links: [
      { label: '女主是谁', href: '#female-lead' },
      { label: '男主设定', href: '#male-lead' },
      { label: '角色图鉴', href: '#gallery' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '人物关系', href: '#relations' },
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-400 text-foreground-950">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg text-background-50">
                泡在我家的辣妹角色介绍
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-100/80">
              专注分享「泡在我家的辣妹」的角色介绍、女主男主设定与人物关系解读，为每一个想入坑的你提供最清晰的入门指南。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-medium text-accent-300">{group.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/80 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 泡在我家的辣妹角色介绍 · 本站为爱好者内容整理
          </p>
          <div className="flex items-center gap-3 text-background-100/60">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10">
              <i className="ri-twitter-x-line text-sm"></i>
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10">
              <i className="ri-weibo-line text-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}